import { apiClient } from '@/lib/api'
import type { GoogleSSOSettings, SessionUser } from '@/types/auth'

export interface GoogleSSOWriteBody {
  client_id: string
  // absent/"" = keep the stored secret (the secret is write-only)
  client_secret?: string
  allowed_domain: string
  // When on, first-time sign-ins with an unknown verified email get a user
  // created with the default role. default_role_id is "" when off/unset.
  auto_provision: boolean
  default_role_id: string
  enabled: boolean
}

// --- admin configuration (session required) ---

export function fetchSSOSettings() {
  return apiClient<GoogleSSOSettings>('/auth/sso/google')
}

export function saveSSOSettings(body: GoogleSSOWriteBody) {
  return apiClient<GoogleSSOSettings>('/auth/sso/google', { method: 'PUT', body })
}

// --- public login ceremony ---

export function fetchSSOStatus() {
  return apiClient<{ enabled: boolean }>('/auth/sso/google/status')
}

// Returns the Google authorization URL to redirect the browser to.
export function startSSOLogin() {
  return apiClient<{ url: string }>('/auth/sso/google/start', { method: 'POST' })
}

// Exchanges the ?code&state the Google redirect dropped on /login for a
// session cookie (the backend sets fp_session on the response).
export function completeSSOLogin(code: string, state: string) {
  return apiClient<SessionUser>('/auth/sso/google/callback', {
    method: 'POST',
    body: { code, state },
  })
}
